"use client";

import { c as _c } from "react/compiler-runtime";
import { Switch } from "@heroui/react";
import { Moon, Sun } from "lucide-react";
import { useLayoutEffect, useState } from "react";
import useThemeToggle from "@hooks/useThemeToggle";
const ThemeToggle = () => {
  const $ = _c(5);
  const [mounted, setMounted] = useState(false);
  const {
    theme,
    toggleTheme
  } = useThemeToggle();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setTimeout(() => setMounted(true), 0);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  if (mounted) {
    const t2 = theme === "dark";
    let t3;
    if ($[2] !== t2 || $[3] !== toggleTheme) {
      t3 = <Switch aria-label="Toggle dark mode" isSelected={t2} onChange={toggleTheme} size="lg">{_temp}</Switch>;
      $[2] = t2;
      $[3] = toggleTheme;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
};
export default ThemeToggle;
function _temp(t0) {
  const {
    isSelected
  } = t0;
  return <Switch.Content><Switch.Control><Switch.Thumb><Switch.Icon>{isSelected ? <Moon size={16} /> : <Sun size={16} />}</Switch.Icon></Switch.Thumb></Switch.Control></Switch.Content>;
}